import { ListaCertificadosAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/pages/certificados/ListaCertificadosAnaliseLaboratorial";
import { NovoCertificadoAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/pages/certificados/NovoCertificadoAnaliseLaboratorial";
import { EdicaoRequisicaoAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/pages/requisicoes/EdicaoRequisicaoAnaliseLaboratorial";
import { ListaRequisicoesAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/pages/requisicoes/ListaRequisicoesAnaliseLaboratorial";
import { NovaRequisicaoAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/pages/requisicoes/NovaRequisicaoAnaliseLaboratorial";
import { VisualizacaoAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/pages/visualizacaoAnaliseLaboratorial/VisualizacaoAnaliseLaboratorial";
import { Route } from "react-router";

// As rotas são renderizadas dentro do layout autenticado em app/routes.tsx.
// Retorna um Fragment (e não um componente) porque <Routes> só aceita
// <Route> ou Fragment como filhos diretos.
export function analiseLaboratorialRoutes() {
  return (
    <>
      <Route
        path="/analises-laboratoriais/requisicoes/lista"
        element={<ListaRequisicoesAnaliseLaboratorial />}
      />
      <Route
        path="/analises-laboratoriais/requisicoes/novo"
        element={<NovaRequisicaoAnaliseLaboratorial />}
      />
      <Route
        path="/analises-laboratoriais/requisicoes/lista/editar/:offlineId"
        element={<EdicaoRequisicaoAnaliseLaboratorial />}
      />
      <Route
        path="/analises-laboratoriais/visualizar/:id"
        element={<VisualizacaoAnaliseLaboratorial />}
      />
      <Route
        path="/analises-laboratoriais/certificados/lista"
        element={<ListaCertificadosAnaliseLaboratorial />}
      />
      <Route
        path="/analises-laboratoriais/certificados/novo/:requisicaoId"
        element={<NovoCertificadoAnaliseLaboratorial />}
      />
    </>
  );
}
